import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../images/site_logo/site_logo_1.svg";
import "../../../src/constant.js";
import { QRCodeCanvas } from "qrcode.react";
import DefaultAvatar from "../../images/shapes/profile-icon-color 3.png";
import {
  FaEdit,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaWallet,
  FaHeadset,
  FaCog,
  FaUserPlus,
  FaShareAlt,
  FaCopy,
} from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import md5 from "md5";
import { API_URL } from "../../../src/constant.js";

const LoginHeaderR = () => {
  const [mobileActive, setMobileState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [userData, setUserData] = useState(null);
  const [referralInfo, setReferralInfo] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    const token = localStorage.getItem("auth_token");
    if (token) {
      setIsLoggedIn(true);
      fetchUserData();
      fetchReferralInfo();
    }

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLoggedIn]);

  const handleReferralHistoryNavigation = (e) => {
    e.preventDefault();
    navigate("/business-agent-referral-history");
  };

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/me`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });
      const data = await response.json();
      setUserData(data.user);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchReferralInfo = async () => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/referral/info`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });
      const data = await response.json();
      setReferralInfo(data);
    } catch (error) {
      console.error("Error fetching referral info:", error);
    }
  };

  const getUserAvatar = () => {
    if (userData?.avatar) return userData.avatar;
    if (userData?.email) {
      const emailHash = md5(userData.email.trim().toLowerCase());
      return `https://www.gravatar.com/avatar/${emailHash}?d=identicon`;
    }
    return DefaultAvatar;
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
    setMobileState(false);
  };

  const confirmLogout = async () => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });

      if (response.ok) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        setIsLoggedIn(false);
        navigate("/work-with-tcuk");
        setShowLogoutConfirm(false);
        setMobileState(false);
        window.location.reload();
      } else {
        console.error("Failed to logout");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const shareReferral = async () => {
    const shareData = {
      title: 'Join TopCoin UK Retail',
      text: referralInfo?.is_advertising_agent 
        ? `Join me on TopCoin UK Retail using my referral code: ${referralInfo?.referral_code}`
        : "Join me on TopCoin UK Retail - The best platform for retail cryptocurrency trading!",
      url: referralInfo?.is_advertising_agent 
        ? referralInfo?.referral_url 
        : "https://topcoinuk.com/work-with-tcuk", 
    };

    if (navigator.share && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else {
      copyToClipboard(shareData.url);
    }
  };

  const headerRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setMobileState(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getReferralButtonText = () => {
    return referralInfo?.is_advertising_agent ? "Manage Referrals" : "Invite";
  };

  const getShareUrl = () => {
    return referralInfo?.is_advertising_agent 
      ? referralInfo?.referral_url 
      : "https://topcoinuk.com/retail-business-signup"; 
  };

  const getShareText = () => {
    return referralInfo?.is_advertising_agent 
      ? `Join me on TopCoin UK Retail using my referral code: ${referralInfo?.referral_code}`
      : "Join me on TopCoin UK Retail - The best platform for retail cryptocurrency trading!";
  };

  return (
    <header
      className={`site_header ${isSticky ? "sticky" : ""}`}
      ref={headerRef}
    >
      <div className="nav_wrapper">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-6 d-flex align-items-center">
              <div className="site_logo">
                <NavLink
                  className="site_link"
                  to="/retail-business/wallet"
                  onClick={ClickHandler}
                >
                  <img loading="lazy" src={Logo} alt="TopCoin Uk" />
                </NavLink>
              </div>
            </div>

            <div className="col-lg-6 d-none d-lg-block">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className={`main_menu_inner collapse navbar-collapse justify-content-center ${
                    mobileActive ? "show" : ""
                  }`}
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list text-uppercase main-menu">
                    <li>
                      <NavLink
                        to="/retail-business/wallet"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Wallet"
                          style={{ color: "#fff" }}
                        >
                          Wallet
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/privacy-policy-r"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Privacy Policy"
                          style={{ color: "#fff" }}
                        >
                          Privacy Policy
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/terms-conditions-r"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Terms & Conditions"
                          style={{ color: "#fff" }}
                        >
                          Terms & Conditions
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            <div className="col-lg-3 col-6">
              <ul className="btns_group unordered_list p-0 justify-content-end">
                <li className="d-lg-none">
                  <button
                    className="mobile_menu_btn"
                    type="button"
                    onClick={() => setMobileState(!mobileActive)}
                    style={{
                      background: "transparent",
                      border: "none",
                      fontSize: "24px",
                      color: "#fff",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    {mobileActive ? (
                      <IoMdClose style={{ fontSize: "28px" }} />
                    ) : (
                      <FaBars />
                    )}
                  </button>
                </li>

                <li
                  className="d-none d-lg-block"
                  style={{ position: "relative" }}
                  ref={dropdownRef}
                >
                  {isLoggedIn ? (
                    <>
                      <div className="d-flex align-items-center gap-2 width: 200px">
                        <button
                          onClick={() => setDropdownOpen(!dropdownOpen)}
                          className="d-flex align-items-center gap-2 "
                          style={{
                            backgroundColor: "#fff",
                            color: "#003087",
                            borderRadius: "12px",
                            padding: "8px 12px",
                            border: "none",
                            fontWeight: "bold",
                          }}
                        >
                          {userData?.email || "Profile"} ▾
                        </button>
                      </div>

                      {dropdownOpen && (
                        <div
                          className="position-absolute"
                          style={{
                            right: 0,
                            top: "calc(100% + 8px)",
                            width: "225px",
                            backgroundColor: "#fff",
                            border: "1px solid #eee",
                            borderRadius: "12px",
                            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
                            zIndex: 9999,
                          }}
                        >
                          {/* <button
                            onClick={() => setShowInviteModal(true)}
                            className="d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: "transparent",
                              color: "#003087",
                              borderRadius: "12px",
                              padding: "8px 12px",
                              border: "1px solid #fff",
                              fontWeight: "bold",
                              marginRight: "8px",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "left",
                              justifyContent: "flex-start",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "rgba(0,48,135,0.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                            }}
                          >
                            <FaUserPlus />
                            {getReferralButtonText()}
                          </button> */}

                          <NavLink
                            to="/retail-business/edit-profile"
                            onClick={() => {
                              setDropdownOpen(false);
                              setMobileState(false);
                            }}
                            className="d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: "transparent",
                              color: "#003087",
                              borderRadius: "12px",
                              padding: "8px 12px",
                              border: "1px solid #fff",
                              fontWeight: "bold",
                              marginRight: "8px",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "left",
                              justifyContent: "flex-start",
                              textDecoration: "none",
                            }}
                          >
                            <FaEdit /> Edit Profile
                          </NavLink>

                          <button
                            onClick={() => {
                              setShowLogoutConfirm(true);
                              setDropdownOpen(false);
                            }}
                            className="d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: "transparent",
                              color: "#003087",
                              borderRadius: "12px",
                              padding: "8px 12px",
                              border: "1px solid #fff",
                              fontWeight: "bold",
                              marginRight: "8px",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "left",
                              justifyContent: "flex-start",
                            }}
                          >
                            <FaSignOutAlt /> Logout
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <NavLink
                      onClick={ClickHandler}
                      className="ico_btn_outline"
                      to="/work-with-tcuk"
                      style={{
                        backgroundColor: "#fff",
                        color: "#003087",
                        padding: "8px 16px",
                        borderRadius: "12px",
                        fontWeight: "bold",
                        border: "none",
                      }}
                    >
                      Join Now
                    </NavLink>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Mobile Menu */}
      <div className={`mobile-menu-wrapper ${mobileActive ? "active" : ""}`}>
        <div className="mobile-menu-container">
          <div className="mobile-menu-header">
            <div
              className="mobile-menu-close"
              onClick={() => setMobileState(false)}
            >
              <IoMdClose size={28} />
            </div>

            {isLoggedIn ? (
              <div className="mobile-profile-card">
                <div className="profile-info">
                  <div className="profile-text">
                    <h4>{userData?.name || "My Account"}</h4>
                    {userData?.email && <p>{userData.email}</p>}
                  </div>
                </div>
                
                <div className="mobile-invite-section">
                  <button
                    onClick={() => setShowInviteModal(true)}
                    className="mobile-invite-btn"
                  >
                    <FaUserPlus className="action-icon" />
                    <span>{getReferralButtonText()}</span>
                  </button>
                </div>

                <div className="profile-actions">
                  <NavLink
                    to="/retail-business/edit-profile"
                    onClick={ClickHandler}
                    className="mobile-nav-link2"
                  >
                    <FaEdit className="action-icon " />
                    <span>Edit Profile</span>
                  </NavLink>
                  <button
                    onClick={() => setShowLogoutConfirm(true)}
                    className="profile-action-btn"
                  >
                    <FaSignOutAlt className="action-icon" />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="mobile-join-section">
                <h3>Join TopCoin Today</h3>
                <p>Access your wallet and start trading</p>
                <NavLink
                  onClick={ClickHandler}
                  className="mobile-join-btn"
                  to="/login#google-login-button"
                >
                  Sign In / Register
                </NavLink>
              </div>
            )}
          </div>

          <nav className="mobile-nav">
            <ul className="mobile-nav-list">
              <li>
                <NavLink
                  to="/retail-business/wallet"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaWallet className="nav-icon" />
                  <span>Wallet</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/privacy-policy-r"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaHeadset className="nav-icon" />
                  <span>Privacy Policy</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/terms-conditions-r"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaCog className="nav-icon" />
                  <span>Terms & Conditions</span>
                </NavLink>
              </li>
            </ul>
          </nav>

          <div className="mobile-footer">
            <p>© {new Date().getFullYear()} TopCoin UK</p>
          </div>
        </div>
      </div>

      {/* Invite Friends Modal */}
      {/* {showInviteModal && (
        <div className="invite-modal-overlay">
          <div className="invite-modal-content">
            <div className="invite-modal-header">
              <h3>
                {referralInfo?.is_advertising_agent 
                  ? "Manage Your Referrals" 
                  : "Invite Friends & Family"}
              </h3>
              <button
                onClick={() => setShowInviteModal(false)}
                className="close-button"
              >
                <IoMdClose size={20} />
              </button>
            </div>

            <div className="invite-modal-body">
              {referralInfo?.is_advertising_agent && (
                <div className="referral-stats" style={{ textAlign: "center" }}>
                  <div className="stat-item" style={{ marginBottom: "10px" }}>
                    <span className="stat-number">
                      {referralInfo.referral_stats?.successful_referrals || 0}
                    </span>
                    <span className="stat-label">Total Joined</span>
                  </div>
                  <div className="stat-item" style={{ textAlign: "center", marginTop: "-5px" }}>
                    <button
                      onClick={handleReferralHistoryNavigation}
                      style={{
                        color: "#0000A0",
                        fontWeight: "500",
                        textDecoration: "none",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "15px",
                      }}
                    >
                      View Referral History &gt;&gt;
                    </button>
                  </div>
                </div>
              )}

              <div className="referral-link-section">
                <label>
                  {referralInfo?.is_advertising_agent 
                    ? "Your Referral Link" 
                    : "Share Our Website"}
                </label>
                <div className="link-display">
                  <span className="referral-link">
                    {getShareUrl()}
                  </span>
                  <button
                    onClick={() => copyToClipboard(getShareUrl())}
                    className="copy-button"
                  >
                    <FaCopy />
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
              </div>

              <div className="qr-code-section" style={{ marginTop: "10px" }}>
                <h4 style={{ marginBottom: "5px", color: "#052C65" }}>
                  {referralInfo?.is_advertising_agent 
                    ? "Scan Your QR Code" 
                    : "Scan to Visit Our Website"}
                </h4>
                <div
                  style={{
                    display: "flex",
                    padding: "0px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <QRCodeCanvas
                    value={getShareUrl()}
                    size={130}
                    level="H"
                    includeMargin={true}
                  />
                </div>
              </div>

              <div className="share-buttons">
                <button onClick={shareReferral} className="share-button primary">
                  <FaShareAlt />
                  Share
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
 */}
      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="logout-confirmation-modal">
          <div className="modal-content">
            <h5>Logout Confirmation</h5>
            <p>Are you sure you want to logout?</p>
            <div className="modal-actions">
              <button onClick={confirmLogout} className="confirm-btn">
                Confirm
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Mobile Menu Wrapper */
        .mobile-menu-wrapper {
          position: fixed;
          top: 0;
          right: -100%;
          width: 85%;
          max-width: 350px;
          height: 100vh;
          background: linear-gradient(135deg, #003087 0%, #001a4d 100%);
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
          z-index: 9998;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow-y: auto;
        }

        .mobile-menu-wrapper.active {
          right: 0;
          width: 80%;
        }

        /* Mobile Menu Container */
        .mobile-menu-container {
          padding: 20px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        /* Header Section */
        .mobile-menu-header {
          margin-bottom: 30px;
        }

        .mobile-menu-close {
          text-align: right;
          margin-bottom: 20px;
          color: #fff;
          cursor: pointer;
        }

        /* Profile Card */
        .mobile-profile-card {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 30px;
          backdrop-filter: blur(5px);
        }

        .profile-info {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 20px;
        }

        .profile-text{
          color: #fff;
          margin: 0;
          font-size: 18px;
        }

        h4 {
          color: #fff;
          margin: 0;
          font-size: 16px;
        }

        .profile-text p {
          color: rgba(255, 255, 255, 0.7);
          margin: 5px 0 0;
          font-size: 14px;
        }

        /* Mobile Invite Section */
        .mobile-invite-section {
          margin-bottom: 15px;
        }

        .mobile-invite-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: #fff;
          padding: 12px 16px;
          border-radius: 8px;
          width: 100%;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .mobile-invite-btn:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        .profile-actions {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .profile-action-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          background: transparent;
          border: none;
          color: #fff;
          padding: 10px;
          border-radius: 8px;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .profile-action-btn:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .action-icon {
          font-size: 18px;
        }

        /* Join Section */
        .mobile-join-section {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 30px;
          text-align: center;
          backdrop-filter: blur(5px);
        }

        .mobile-join-section h3 {
          color: #fff;
          margin: 0 0 10px;
          font-size: 18px;
        }

        .mobile-join-section p {
          color: rgba(255, 255, 255, 0.7);
          margin: 0 0 15px;
          font-size: 14px;
        }

        .mobile-join-btn {
          display: inline-block;
          background: #fff;
          color: #003087;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: bold;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .mobile-join-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        /* Navigation */
        .mobile-nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .mobile-nav-list li {
          margin-bottom: 5px;
        }

        .mobile-nav-link {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 15px;
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link2 {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 10px;
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .mobile-nav-link2:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .nav-icon {
          font-size: 20px;
          width: 24px;
          text-align: center;
        }

        /* Footer */
        .mobile-footer {
          margin-top: auto;
          padding-top: 20px;
          text-align: center;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
        }

        /* Invite Modal */
        .invite-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 10000;
          padding: 20px;
        }

        .invite-modal-content {
          background: #fff;
          border-radius: 20px;
          width: 100%;
          max-width: 600px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .invite-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 25px 25px 10px;
        }

        .invite-modal-header h3 {
          color: #052C65;
          margin: 0;
          font-size: 24px;
          font-weight: bold;
        }

        .close-button {
          background: none;
          border: none;
          color: #323232;
          cursor: pointer;
          padding: 5px;
          border-radius: 50%;
          transition: background 0.3s ease;
          margin-top: -40px;
          margin-right: -10px;
        }

        .close-button:hover {
          background: #f5f5f5;
        }

        .invite-modal-body {
          padding:25px;
        }

        /* Referral Stats */
        .referral-stats {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          gap: 0px;
          margin-bottom: 10px;
          padding: 20px;
          border: 1px solid #999999;
          border-radius: 12px;
          color: 000000;
          width: 65%;
          margin-left: 100px;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
        }

        .stat-number {
          font-size: 1.8rem;
          font-weight: bold;
        }

        .stat-label {
          font-size: 0.85rem;
          opacity: 0.9;
          font-weight: bold;
        }

        /* Referral Link Sections */
        .referral-link-section {
          margin-bottom: 20px;
        }

        .referral-link-section label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #052C65;
        }

        .link-display {
          display: flex;
          align-items: center;
          gap: 10px;
          border: 1px solid #999999;
          border-radius: 12px;
          padding: 5px 15px;
        }

        .referral-link {
          flex: 1;
          font-family: monospace;
          font-size: 0.9rem;
          color: #495057;
          word-break: break-all;
        }

        .copy-button {
          display: flex;
          align-items: center;
          gap: 5px;
          background: #003087;
          color: white;
          border: none;
          padding: 6px 20px;
          border-radius: 8px;
          font-size: 0.85rem;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .copy-button:hover {
          background: #001a4d;
        }

        /* Share Buttons */
        .share-buttons {
          display: flex;
          margin-left: 180px;
          gap: 12px;
          margin-bottom: 25px;
          width: 35%;
          margin-top: 15px;
        }

        .share-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex: 1;
          padding: 10px;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .share-button.primary {
          background: #003087;
          color: white;
        }

        .share-button.primary:hover {
          background: #001a4d;
          transform: translateY(-2px);
        }

        /* Logout Confirmation Modal */
        .logout-confirmation-modal {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
        }

        .modal-content {
          background: #fff;
          padding: 30px;
          border-radius: 20px;
          width: 90%;
          max-width: 320px;
          text-align: center;
          box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
        }

        .modal-content h5 {
          color: #003087;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .modal-content p {
          color: #666;
        }

        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          gap: 10px;
        }

        .confirm-btn {
          background: #003087;
          color: #fff;
          padding: 10px 20px;
          border-radius: 12px;
          border: none;
          font-weight: bold;
          flex: 1;
          cursor: pointer;
        }

        .cancel-btn {
          border: 1px solid #003087;
          color: #003087;
          padding: 10px 20px;
          border-radius: 12px;
          background: #fff;
          font-weight: bold;
          flex: 1;
          cursor: pointer;
        }

        /* Responsive adjustments */
        @media (max-width: 480px) {
          .mobile-menu-wrapper {
            width: 90%;
          }
          
          .referral-stats {
            padding: 15px;
            margin-left: 50px;
          }
          
          .stat-number {
            font-size: 1.5rem;
          }
          
          .share-buttons {
            flex-direction: column;
            margin-left: 95px;
          }
          
          .invite-modal-body {
            padding: 20px;
          }
        }

        /* Mobile Menu Wrapper */
        .mobile-menu-wrapper {
          position: fixed;
          top: 0;
          right: -100%;
          width: 85%;
          max-width: 350px;
          height: 100vh;
          background: linear-gradient(135deg, #003087 0%, #001a4d 100%);
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
          z-index: 9998;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow-y: auto;
        }

        .mobile-menu-wrapper.active {
          right: 0;
          width: 80%;
        }
      `}</style>
    </header>
  );
};

export default LoginHeaderR;